import React from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

function Navbar() {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/');
    };

    let user = null;
    const token = localStorage.getItem('token');
    if (token) {
        try {
            user = JSON.parse(atob(token));
        } catch (err) {
            console.error('Invalid token format');
        }
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow">
            <div className="container-fluid">
                <span
                    className="navbar-brand"
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate('/dashboard')}
                >
                    🛡️ Visitor Management
                </span>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon" />
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <NavLink to="/visitor-entry" className="nav-link">📝 Visitor Entry</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/visitor-show" className="nav-link">👁️ Show Visitors</NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink to="/visitor-approval" className="nav-link">✅ Visitor Approval</NavLink>
                        </li>
                        <li className="nav-item">
                           <NavLink to="/visitor-out/list" className="nav-link">🚪 Visitor Out Process</NavLink>

                        </li>
                        <li className="nav-item">
                            <NavLink to="/visitor-reports" className="nav-link">📊 Reports</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/team-management" className="nav-link">👥 Team Management</NavLink>
                        </li>

                        {/* ✅ Settings Dropdown */}
                        <li className="nav-item dropdown">
                            <span
                                className="nav-link dropdown-toggle"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                ⚙️ Settings
                            </span>
                            <ul className="dropdown-menu">
                                <li hidden><NavLink to="/settings/waba" className="dropdown-item">📤 WABA Configuration</NavLink></li>
                                <li hidden><NavLink to="/settings/email" className="dropdown-item">✉️ Email Setup</NavLink></li>
                                <li><NavLink to="/settings/security-materials" className="dropdown-item">🧰 Security Material List</NavLink></li>
                                <li><NavLink to="/settings/visitor-types" className="dropdown-item">👥 Visitor Types</NavLink></li>
                                <li><NavLink to="/settings/visit-purposes" className="dropdown-item">📋 Visit Purposes</NavLink></li>
                            </ul>
                        </li>
                    </ul>

                    {user && (
                        <span className="navbar-text me-3 text-white">
                            {user.name} ({user.role})
                        </span>
                    )}

                    <button className="btn btn-outline-light btn-sm" onClick={handleLogout}>
                        Logout
                    </button>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
